/**
 * 유틸
 * @category common
 * @example
 * import Utils from '../common/Utils';
 * Utils.namespace('nc.lineage2.sampleApp');
*/
class Utils {
    constructor(){}

    /**
     * namespace 를 확인후 해당 네임스페이스가 없을 경우 만들어서 리턴
     * @param  {} _namespace='window.console'
     * @param  {} _parent=window
     * @returns {Object}
     * @example
     * Utils.namespace('nc.lineage2.sampleApp');
     * var testApp = new nc.lineage2.sampleApp();
     */
    static namespace (_namespace = 'window.console', _parent = window) {
        if ( typeof _namespace === 'string' && _namespace ) {
            let parts = _namespace.split('.');
            for (let i = 0, max = parts.length; i < max; i++) {
                if (!_parent[parts[i]]) _parent[parts[i]] = {};
                _parent = _parent[parts[i]];
            }
        }
        return _parent;
    }


    /**
     * URL 파라미터 키네임으로 값 가져오기
     * @param  {String} name 키네임
     * @param  {String} url 필수아님
     * @returns {String}
     * @example
     * Utils.getParamByName('query'); // return '검색어'
     * Utils.getParamByName('query', 'https://lineage.plaync.com/search/index?query=test'); // return 'test'
     */
    static getParamByName( name, url ) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    

    static replaceTag( text ) {
        if ( !text ) return '';
        return text.replace( /</g, '&lt;' ).replace( />/g, '&gt;' );
    }
    

} // end of class
export default Utils;